import { render, staticRenderFns } from "./AgeChart.vue?vue&type=template&id=ec88f4d6&scoped=true&"
import script from "./AgeChart.vue?vue&type=script&lang=ts&"
export * from "./AgeChart.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec88f4d6",
  null
  
)

export default component.exports